import {
  Component,
  OnInit,
  ViewChild,
  Input,
  ViewChildren,
  AfterViewInit,
  QueryList,
} from "@angular/core";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  FormArray,
  UntypedFormBuilder,
} from "@angular/forms";
import { DaoService } from "./../../services/dao.service";
import { Router } from "@angular/router";
import { DataSource } from "@angular/cdk/table";
// import {
//   MatTableDataSource,
//   MatDialog,
//   MatPaginator,
//   MAT_DIALOG_DATA,
//   MatDialogRef,
// } from "@angular/material";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from "@angular/material/dialog";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatDialogRef } from "@angular/material/dialog";

import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { LstorageService } from "./../../services/lstorage.service";
import * as jwtDecode from "jwt-decode";
import { SpinnerService } from "src/app/shared/spinner/spinner.service";
import { SpinnerComponent } from "src/app/shared/spinner/spinner.component";
import { MatSort } from "@angular/material/sort";
import { UserdeleteComponent } from "../userdelete/userdelete.component";
import { decryptData, encryptData } from "src/app/services/aes.service";

@Component({
  selector: "app-api-response-mapping-list",
  templateUrl: "./api-response-mapping-list.component.html",
  styleUrls: ["./api-response-mapping-list.component.scss"],
})
export class ApiResponseMappingListComponent implements OnInit {
  // private paginator: MatPaginator;
  private parentPaginator: MatPaginator;
  responseMappingList: any;
  parentselected = [];
  apiResponseData: any;
  apiData: any;
  dataSource: any;
  parentDatasource: any;
  displayedcolumns: string[] = ["Sno", "name", "edit", "delete"];
  parentdisplayedcolumns: string[] = ["Sno", "name"];
  pageIndex: number;
  pageSize: number;
  length: number;
  parentpageIndex: number;
  parentpazesize: number;
  parentlength: number;
  loader = false;
  pageEvent: PageEvent;
  apiParentId: any;
  parentAttrinbute: any;
  paginationAttribute: any;
  createdby: any;
  apiDynamicAttribue: any;
  apiPagination = new FormGroup({
    ApiId: new FormControl(),
    IsPagination: new FormControl(),
    Count: new FormControl(),
    Parameter: new FormControl(),
    isActive: new FormControl(),
    createdBy: new FormControl(),
    createdOn: new FormControl(),
    modifiedBy: new FormControl(),
    modifiedOn: new FormControl(),
  });

  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();

  constructor(
    private daoService: DaoService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private token: LstorageService,
    private spinner: SpinnerService,
    public dialog: MatDialog
  ) {
    this.apiResponseData = this.token.getApiResponse();
    //this.apiDynamicAttribue = this.token.getApiDyanamicAttribute();
    //this.apiDynamicAttribue = this.apiDynamicAttribue.sort();
  }

  ngOnInit() {
    this.apiData = this.token.getApiData();
    var apiId = this.token.getApiId();
    console.log("MappingapiId", apiId);
    //Response for pagination

    var pAttribute = [];
    var data1 = {
      GroupId: apiId,
    };
    this.daoService
      .getParentAttribute(encryptData(JSON.stringify(data1)))
      .subscribe((data: any) => {
        let grp = JSON.parse(decryptData(data.key));
        console.log("MappingapiId", apiId);
        grp.forEach(function (value) {
          value.name = "response." + value.name;
          pAttribute.push(value);
          console.log("response attribute");
          console.log(pAttribute);
        });
        this.apiDynamicAttribue = pAttribute;
        console.log(this.apiDynamicAttribue);
      });

    //Pagination
    this.apiPagination = this.formBuilder.group({
      ApiId: [""],
      IsPagination: false,
      Count: [""],
      Parameter: this.formBuilder.array([this.getParameter()]),
      CreatedBy: "",
      createdOn: "2020-03-29T12:26:18.986Z",
      ModifiedBy: "",
      modifiedOn: "2020-03-29T12:26:18.986Z",
    });

    //Edit pagination
    this.daoService.getApiPagination(apiId).subscribe((data: any) => {
      console.log("Pagination Get by id");
      console.log(data);
      if (data) {
        var dynamicParameter = this.formBuilder.array([]);
        for (var i = 0; i < data.parameter.length; i++) {
          dynamicParameter.push(
            this.bindParameter(
              data.parameter[i].attribute,
              data.parameter[i].attributeMap,
              data.parameter[i].parameterType
            )
          );
        }

        this.apiPagination = this.formBuilder.group({
          ApiId: apiId,
          IsPagination: data.isPagination,
          Count: [data.count],
          Parameter: dynamicParameter,
          CreatedBy: "",
          createdOn: "2020-03-29T12:26:18.986Z",
          ModifiedBy: "",
          modifiedOn: "2020-03-29T12:26:18.986Z",
        });
      }
    });

    this.apiParentId = this.token.getParentId();
    this.createdby = jwtDecode(this.token.getToken());
    console.log("this.createdby");
    console.log(this.createdby.unique_name);
    // this.spinner.show();
    this.daoService
      .getResponseMappingList(encryptData(JSON.stringify(data1)))
      .subscribe(
        (data: any) => {
          let grp = JSON.parse(decryptData(data.key));
          this.spinner.hide();
          this.daoService.defaultResponseMappingList(grp);
          this.daoService.finalresponsemappingList.subscribe(
            (responsemappingList) =>
              (this.responseMappingList = responsemappingList)
          );
          this.dataSource = new MatTableDataSource(this.responseMappingList);
          this.dataSource.paginator = this.paginator.toArray()[0];
          this.dataSource.sort = this.sort.toArray()[0];
          // this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
          console.log("Error:" + error);
        }
      );

    if (this.apiParentId != "0") {
      //this.spinner.show();
      this.daoService
        .getParentAttribute(this.apiParentId)
        .subscribe((data: any) => {
          this.spinner.hide();
          this.parentAttrinbute = data;
          this.parentDatasource = new MatTableDataSource(this.parentAttrinbute);
          this.parentDatasource.paginator = this.paginator.toArray()[1];
          console.log("this.parentDatasource.paginator");
          console.log(this.parentDatasource.paginator);
          this.parentDatasource.sort = this.sort.toArray()[1];
        });
      this.daoService.getParentResponseMappingList(this.apiParentId).subscribe(
        (data: any) => {
          this.parentselected = data.attributes;
        },
        (error) => {
          this.spinner.hide();
          console.log("Error:" + error);
        }
      );
    }
  }

  onChange(event, parentAttribute) {
    if (event) {
      this.spinner.show();
      this.parentselected.push(parentAttribute);
      var parent = {
        apiId: this.apiParentId,
        attributes: this.parentselected,
        isActive: true,
        createdBy: this.createdby.unique_name,
        createdOn: "2020-03-29T12:26:18.986Z",
        ModifiedBy: this.createdby.unique_name,
        modifiedOn: "2020-03-29T12:26:18.986Z",
      };
      this.daoService.addParentResponse(parent).subscribe(
        (data: any) => {
          this.spinner.hide();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
    } else {
      this.spinner.show();
      this.parentselected.splice(
        this.parentselected.indexOf(parentAttribute),
        1
      );
      var parent1 = {
        apiId: this.apiParentId,
        attributes: this.parentselected,
        isActive: true,
        CreatedBy: this.createdby.unique_name,
        createdOn: "2020-03-29T12:26:18.986Z",
        ModifiedBy: this.createdby.unique_name,
        modifiedOn: "2020-03-29T12:26:18.986Z",
      };
      this.daoService.addParentResponse(parent1).subscribe(
        (data: any) => {
          this.spinner.hide();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
    }
  }

  checkedAttribute(attribute) {
    if (this.parentselected && this.parentselected.indexOf(attribute) != -1) {
      return true;
    }
  }

  public gotoResponseMappingForm() {
    this.token.clearResponseMappingId();
    this.router.navigate(["/responseMappingForm"]);
  }

  public editResponseMapping(mappingId) {
    this.token.saveResponseMappingId(mappingId);
    this.router.navigate(["/responseMappingForm"]);
  }

  public backtoApiManager() {
    this.token.saveApiManagerId(this.token.getApiId());
    this.router.navigate(["/apiManager"]);
  }

  deleteResponseMapping(id) {
    this.daoService.defaultresponseMappingId(id);
    this.daoService.responseMappingDelete(true);
    const dialogRef = this.dialog.open(UserdeleteComponent, {
      disableClose: true,
      panelClass: "custom-dialog-container",
      width: "376px",
      height: "145px",
      autoFocus: true,
    });
    dialogRef.beforeClosed().subscribe((userList) => {
      this.daoService.responseMappingDelete(false);
      this.daoService.finalresponsemappingList.subscribe(
        (responseMappingList) =>
          (this.responseMappingList = responseMappingList)
      );
      this.dataSource = new MatTableDataSource(this.responseMappingList);
      this.daoService.defaultresponseMappingId(null);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  removeFromArrayOfHash(p_array_of_hash, p_key, p_value_to_remove) {
    return p_array_of_hash.filter((l_cur_row) => {
      return l_cur_row[p_key] != p_value_to_remove;
    });
  }

  //For store pagination details
  public handlePage(e: any) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.length = e.length;
  }

  public handlePageParent(e: any) {
    this.parentpageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.parentlength = e.length;
  }

  //Pagination begin
  //Dynamic Mapping Begin
  private getParameter() {
    return this.formBuilder.group({
      Attribute: [""],
      parameterType: [""],
      AttributeMap: [""],
    });
  }

  private bindParameter(Attribute, AttributeMap, isPositional) {
    return this.formBuilder.group({
      Attribute: [Attribute],
      AttributeMap: [AttributeMap],
      parameterType: [isPositional],
    });
  }

  addParameter() {
    //const control = <FormArray>this.apiPagination.controls['Parameter'];
    const control = this.apiPagination.get("Parameter") as FormArray;

    control.push(this.getParameter());
  }

  removeParameter(i: number) {
    // const control = <FormArray>this.apiPagination.controls['Parameter'];
    const control = this.apiPagination.get("Parameter") as FormArray;

    control.removeAt(i);
    if (i == 0) {
      control.push(this.getParameter());
    }
  }

  clearAllParameter() {
    const control = this.apiPagination.get("Parameter") as FormArray;
    while (control.length) {
      control.removeAt(control.length - 1);
    }
    control.clearValidators();
    control.push(this.getParameter());
  }

  //Add Api Pagination
  addApiPagination() {
    var formdata = {
      apiId: this.token.getApiId(),
      isPagination: this.apiPagination.value.IsPagination,
      count: this.apiPagination.value.Count,
      parameter: this.apiPagination.value.Parameter,
      isActive: true,
      createdBy: this.createdby.unique_name,
      createdOn: "2020-03-29T12:26:18.986Z",
      modifiedBy: "9698692298",
      modifiedOn: "2020-03-29T12:26:18.986Z",
    };
    this.spinner.show();
    this.apiPagination.value.ApiId = this.token.getApiId();
    this.daoService.addApiPagination(formdata).subscribe(
      (data: any) => {
        this.spinner.hide();
      },
      (error) => {
        console.log(error);
        this.spinner.hide();
      }
    );
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    if (this.apiPagination.value.Count.length > 2) {
      return false;
    }
    return true;
  }
}
